import React, { Component } from "react"
import { Button, Icon, Table, Progress, Upload, message } from "antd"
import CModal from "../../CModal"
import "./Index.scss"
import { observer, inject } from "mobx-react"
import stores from "./stores"
import { TASK_TYPE } from "./stores/TaskModel"
import { getCurrentApp } from "app/api/localTools"
import { ACTIVE, SUCCESS, INACTIVE } from "./stores/File"
import FlexableFileName from "app/components/normal/FlexableFileName"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import lightning from "app/styles/images/sp/lightning.svg"
import cx from "classnames"

const ObserverProgress = observer(({task, index}) => {
  let info = task.type === TASK_TYPE.file ? task.progress + "%" : task.successCount + "/" + task.size
  return (
    <div className="progress-container">
      {task.type === TASK_TYPE.file && task.isQuickUpload &&
        <img className="quick-label" src={lightning} alt='' />
      }
      <span className="progress-bar">
        <Progress
          title={task.type === TASK_TYPE.file
            ? (task.isError ? task.errorInfo : null)
            : task.statusText
          }
          percent={task.progress}
          showInfo={false} strokeWidth={5} status={task.status === INACTIVE ? ACTIVE : task.status} />
      </span>
      <span>{info}</span>
    </div>
  )
})

const ObserverOperation = observer(({task, onDeleteFile, onAddFile}) => {
  const OPERATE_ICONS = {
    [ACTIVE]: <Icon type="minus-circle" />,
    [SUCCESS]: <Icon type="check-circle" style={{color: '#00a854'}} />
  }
  let operateIcon = OPERATE_ICONS[task.status]
  if (!task.isSuccess && task.unReachable) { // 单任务没有该字段，必不执行，只对组任务有效
    operateIcon = <Icon type="minus" />
  }

  return (
    <div className="ta-c">
      {
        operateIcon || <Icon type="close-circle" onClick={onDeleteFile} title='删除' />
      }
      {/* 如果控制 dom 结构的话，会导致绑定的对应的回调同时被卸载 */}
      <Upload
        multiple
        style={{display: task.type === TASK_TYPE.group && !task.isSuccess ? "visible" : "none"}}
        beforeUpload={onAddFile}>
        <Icon type="plus-circle-o" style={{marginLeft: 5}} title='添加' />
      </Upload>
    </div>
  )
})

@inject("manager")@observer
export default class UploadModal extends Component {
  columns = [{
    title: "家系/文件名称",
    dataIndex: "name",
    render: (text, task) => {
      if (task.type === TASK_TYPE.group) {
        return <MaterialTip title={text}><a className="ellipsis">{text}</a></MaterialTip>
      } else {
        return (
          <a className="expanded-filename">
            <FlexableFileName filename={text} matched={task.file.matched}>
            {task.reference &&
              <Icon style={{color: "#f8b62d", fontSize: "16px", marginLeft: "7px"}} type="star" />
            }
            </FlexableFileName>
          </a>
        )
      }
    }
  }, {
    title: (<div className="ta-r">文件数量/大小</div>),
    dataIndex: "size",
    width: 200,
    render: (size, task, index) => {
      if (task.type === TASK_TYPE.group) {
        return <div className="span-blue ta-r">{task.size}条</div>
      } else {
        return (
          <div className="ta-r">
            {size/1024 >= 1 ?
              size/1024/1024 >= 1 ?
              `${Math.round(size/1024/1024)}MB` :
              `${Math.round(size/2014)}KB` :
              `${size}Bite`
            }
          </div>
        )
      }
    }
  }, {
    title: (<div className="ta-r progress-title">上传进度</div>),
    dataIndex: "progress",
    width: 350,
    render: (progress, task, index) =>
      <ObserverProgress task={task} index={index} />
  }, {
    title: <div className="ta-c">操作</div>,
    dataIndex: "operate",
    width: 60,
    render: (operate, task, index) =>
      <ObserverOperation
        task={task}
        onDeleteFile={() => this.props.onDelete(task)}
        onAddFile={(file) => this.onAddFile(task, file)}
      />
  }]

  getRowKey = row => {
    if (row.type === TASK_TYPE.file) {
      return row.file.uid
    } else {
      return row.name
    }
  }

  onAddFile = (groupTask, file) => {
    const { allowSuffix } = stores.manager.currentTask
    if(allowSuffix!=="*") {       // 验证上传文件的后缀是
      const fileType = file.name.split(".").pop()
      const acceptable = new RegExp(fileType).test(allowSuffix)
      if(!acceptable){
        message.error("请您上传测序结果文件^.^")
        return false
      }
    }

    let { addFileTask, checkDuplicate } = stores.manager.currentTask

    // 门槛条件
    if(file.size === 0) {
      message.error("不能上传空文件 " + file.name)
      return false
    }
    if(checkDuplicate(groupTask, file)) {
      message.error("上传文件重复 " + file.name + ", 请重新选择 ")
      return false
    }

    addFileTask(groupTask, file)
    .catch(error => message.error(error))

    return false
  }

  reload = () => {
    this.props.onReload()
    this.props.manager.currentTask.startUpload()
    .then(null, error => {
      message.error(error)
    })
  }

  // 监听事件
  unload () {
    event.returnValue = "警告：您当前正在上传数据中，关闭页面会造成数据丢失或损坏，请点击取消按钮！"
  }

  render () {
    const { visible } = this.props
    const { currentTask: { preparedGroups, isPending } } = this.props.manager

    if (!isPending) {
      window.removeEventListener("beforeunload", this.unload)
    } else {
      window.addEventListener("beforeunload", this.unload) // 添加窗口关闭警告事件
    }

    return (
      <CModal
        visible={visible}
        closable={false}
        wrapClassName="vertical-center-modal"
        className="upload-modal progress-modal"
        width={934}>
        {this.renderHeader()}
        <Table
          className="progress-table"
          columns={this.columns}
          dataSource={preparedGroups}
          expandIconAsCell={false}
          rowKey={this.getRowKey}
          pagination={false}
          renderKey="id"
          scroll={{ x: true, y: 370 }}
          style={{margin: "10px 0"}}
        />
      </CModal>
    )
  }

  renderHeader = () => {
    const {currentTask: {
      filesCount, successCount, preparedGroups, progress, status, isError, waiting, waitingTime, isPending
    } } = this.props.manager

    return (
      <div className="progress-modal-header">
        <div className="left-part">
          {this.props.type === "singleGroup"
            ? <button
              disabled={isPending}
              className={cx("blue-btn base-btn", {"disable": isPending})}
              type="primary"
              size="default"
              onClick={() => location.reload()}>
              返回家系详情
            </button>
            : (<Button type="primary" size="large">
              <a href={`/public/main/${getCurrentApp()}/dashboard`} target="_blank">进入控制台</a>
            </Button>
            )
          }
          {isError &&
            <Button
              type="ghost"
              size="large"
              onClick={this.reload}>
              <Icon type="reload" />重试
            </Button>
          }
          {(waiting && !isError) &&
            <span>
              <span className="time-number">{waitingTime}s</span> 后将进行自动重试上传
            </span>
          }
        </div>
        <div className="right-part">
          <div>
            共有<span className="span-blue">{filesCount}</span>条数据，
            并分为<span className="span-blue">{preparedGroups.length}</span>组上传</div>
          <span className="total-progress">
            <Progress showInfo={false} percent={progress} strokeWidth={10}
              status={status === INACTIVE ? ACTIVE : status} />
          </span>
          <span>{successCount + "/" + filesCount}</span>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/BasicModal/UploadModal/UploadProgressModal.js